import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ViewPageComponent } from 'src/app/view/pages/view-page/view-page.component';
import { WidgetConfigResolver } from 'src/app/widget-auth/widget-config-resolver';
import { WidgetMasterComponent } from 'src/app/widget/pages/widget-master/widget-master.component';
import { environment } from 'src/environments/environment';
import { ErrorComponent } from 'src/app/pages/error/error.component';

const routes: Routes = [
  {
    path: '',
    component: WidgetMasterComponent,
    resolve: {
      widgetUrlConfig: WidgetConfigResolver,
    },
    children: [
      {
        path: '',
        component: ViewPageComponent,
      },
      {
        path: 'error',
        component: ErrorComponent
      }
    ],
  }
];

const routeImports = environment.offline === true ? RouterModule.forRoot(routes, {useHash: true}) : RouterModule.forRoot(routes);

@NgModule({
  imports: [routeImports],
  exports: [RouterModule],
  providers: [WidgetConfigResolver]
})
export class AppViewerRoutingModule { }
